import React from 'react';
import moment from 'moment';

export default class BookedAssetRow extends React.Component {
  RenderButtonAction() {
  	let status = this.props.RowData.Status;
  	if( status === 'confirmed') {
  		return (
  			<strong onClick={(e)=>{e.stopPropagation();this.props.self.toggleModalCancelBooking(this.props.RowData)}} title="status Booking" className="btn-badge s-confirmed">{status}</strong>
  		)
  	} else if (status === 'ongoing') {
  		return (
  			<strong onClick={(e)=>e.stopPropagation()} title="status Booking" className="btn-badge s-ongoing">{status}</strong>
  		)
  	} else if (status === 'reassign') {
  		return (
  			<strong onClick={(e)=>e.stopPropagation()} title="status Booking" className="btn-badge s-booked">{status}</strong>
  		)
  	} else {
  		return (
  			<strong onClick={(e)=>e.stopPropagation()} title="status Booking" className="btn-badge s-booked">{status}</strong>
  		)
  	}
  }

  RenderReschedule(){
    let status = this.props.RowData.Status
    if (status !== 'confirmed'){
      return (
        <div className="small text-muted date-booked">
            <span >
              From : <span>{moment(this.props.RowData.StartDate).format('ll')}</span> - <span>{moment(this.props.RowData.FinishDate).format('ll')}</span>
            </span>
        </div>
      )
    }else{
      return(
        <div className="small text-muted date-booked">
            <span onClick={(e)=>{e.stopPropagation();this.props.self.toggleModalRescheduleDate(this.props.RowData)}}>
              From : <span>{moment(this.props.RowData.StartDate).format('ll')}</span> - <span>{moment(this.props.RowData.FinishDate).format('ll')}</span> <span className="icon-pencil btn-edit-date"></span>
            </span>
        </div>
      )
    }
  }

  render() {
    // constructor.log('BookedAssetRow render');
    const {RowData} = this.props

    return (
      <tr onClick={(e)=>{e.stopPropagation();this.props.self.toggleModalDetail(RowData.Asset)}}>
        <td>
          <div role="button">
          	<strong>
              <span className="spaceR">{RowData.Asset.Name}</span></strong>
              <span>{RowData.Description !== "" && "(" + RowData.Description + ")"}</span>
          </div>
        </td>
        <td>
          <span>{this.props.self.props.UserReducer.props.first_name}&nbsp;{this.props.self.props.UserReducer.props.last_name}</span>
          <div className="text-muted">
            <small>Username: (&nbsp;{this.props.self.props.UserReducer.username}&nbsp;)</small>
          </div>
        </td>
        <td>
          <span>{RowData.Asset.SerialNumber}</span>
        </td>
        <td>
          <span>{RowData.Site.Name}</span>
        </td>

        <td>
          <span>{RowData.Location.Name}</span>
        </td>
        <td className="text-center">
          {this.RenderButtonAction()}
          {this.RenderReschedule()}
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/home/helper/component/BookedAsset/BookedAssetRow.js